// File: src/pages/Community.jsx

import React from "react";
import CommonHeader from "../components/common/CommonHeader";
import FooterLinks from "../components/LandingPage/FooterLinks";
import CommonSlogan from "../components/common/CommonSlogan";
import CommonFooter from "../components/common/CommonFooter";

export default function Community() {
  return (
    <div className="bg-black text-white min-h-screen">
      <CommonHeader />

      <main className="max-w-3xl mx-auto py-16 px-4">
        <h1 className="text-3xl font-bold mb-6">
          Community: Your Global Financial Network
        </h1>
        <article className="space-y-8">
          <p className="text-lg leading-relaxed text-gray-200">
            Welcome to the beating heart of Million2Trillion: the Community hub.  
            <br /><br />
            In a world where information is power and connections shape success, our community is more than a forum—it's a thriving network of market professionals, traders, investors, educators, and innovators from every corner of the globe. Here, the world's brightest financial minds come together to learn, share, collaborate, and build lasting relationships.
          </p>

          <h2 className="text-2xl font-semibold mt-10 mb-2 text-yellow-300">What Makes the M2T Community Unique?</h2>
          <ul className="list-disc list-inside ml-4 text-gray-300 space-y-2">
            <li>
              <strong>Expert Rooms & Live Sessions:</strong> Join real-time conversations with verified experts, book private sessions, and gain market insights you won't find anywhere else.
            </li>
            <li>
              <strong>Global Forums:</strong> Ask questions, share knowledge, and engage in debates with professionals across every market sector—from forex to crypto, stocks to startups.
            </li>
            <li>
              <strong>Trending Topics & Top Profiles:</strong> Stay ahead of the curve by following trending trades, hot topics, and the profiles making the biggest impact.
            </li>
            <li>
              <strong>Mentorship and Collaboration:</strong> Find mentors, build your team, or offer your expertise to those who need it. Our smart matching connects you with the right people at the right time.
            </li>
            <li>
              <strong>Verified Members Only:</strong> Every community member is authenticated through our SmartCard system, ensuring a safe, spam-free environment where genuine connections flourish.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-10 mb-2 text-yellow-300">How Can You Benefit?</h2>
          <ul className="list-disc list-inside ml-4 text-gray-300 space-y-2">
            <li>
              <strong>Expand Your Network:</strong> Connect with traders, analysts, investors, and educators around the world—instantly and securely.
            </li>
            <li>
              <strong>Access Real Insights:</strong> Learn directly from those on the frontlines of market action, participate in live expert rooms, or simply browse the latest forum threads.
            </li>
            <li>
              <strong>Build Your Reputation:</strong> Share your analysis, offer mentorship, and climb the rankings to become a recognized thought leader in your field.
            </li>
            <li>
              <strong>Get Help & Support:</strong> Whether you’re facing a trading challenge, need a second opinion, or want to learn something new—our community is here for you 24/7.
            </li>
            <li>
              <strong>Book Live Sessions:</strong> Use the booking system to schedule one-on-one meetings or group discussions with verified experts—on your schedule.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-10 mb-2 text-yellow-300">What’s Coming to M2T Community?</h2>
          <ul className="list-disc list-inside ml-4 text-gray-300 space-y-2">
            <li>
              <a className="text-blue-400 underline" >Expert Room</a> — Dive into exclusive rooms led by market leaders and share ideas live.
            </li>
            <li>
              <a className="text-blue-400 underline" >Live Experts</a> — Instantly connect with experts who are live now and ready to help.
            </li>
            <li>
              <a className="text-blue-400 underline" >Book Session</a> — Schedule a session with any verified expert in just a few clicks.
            </li>
            <li>
              <a className="text-blue-400 underline" >Forum</a> — Participate in public discussions, ask questions, and find answers.
            </li>
            <li>
              <a className="text-blue-400 underline" >Members</a> — See the list of verified, active members across all roles and regions.
            </li>
            <li>
              <a className="text-blue-400 underline" >Trending</a> &amp; <a className="text-blue-400 underline" href="/trending/profiles">Top Profiles</a> — Stay up to date with the latest action and most influential voices.
            </li>
            <li>
              <a className="text-blue-400 underline" >Popular Trades</a> — Discover top-performing trades and the strategies behind them.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-10 mb-2 text-yellow-300">Why Is Our Community Different?</h2>
          <p className="text-lg text-gray-200">
            Most online financial forums are noisy, anonymous, and filled with spam or misinformation. The Million2Trillion Community is carefully curated, professionally moderated, and only accessible to verified SmartCard members.  
            <br /><br />
            Here, your ideas are valued, your reputation is built on contribution, and your connections are truly global. Whether you want to learn, teach, share, or grow, you’ll find your tribe here.
          </p>

          <p className="text-lg leading-relaxed text-yellow-400 font-bold mt-8">
            The new Million2Trillion Community platform is launching soon.<br/>
            Real people. Real expertise. Real growth—together.
          </p>
        </article>
      </main>

      <FooterLinks />
      <CommonSlogan />
      <CommonFooter />
    </div>
  );
}
